"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import { workScopeStatusOptions } from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.mudAndTapeInfo"

function HomeMudTapeForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillMudAndTapeOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillMudAndTapeOn` })
    
    // Watch status field and claimed by field
    const mudAndTape = useWatch({ control, name: `${BASE_FIELD_NAME}.mudAndTape` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillMudAndTape = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillMudAndTape` })
    const goodwillMudAndTapeClaimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillMudAndTapeClaimedBy` })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: mudAndTape,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillMudAndTape,
        claimedBy: goodwillMudAndTapeClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillMudAndTapeClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillMudAndTapeOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Mud and Tape"
            wrapperClassName="xl:grid-cols-2"
        >
            <FormSelectInput
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Mud and Tape" toggleName={`${BASE_FIELD_NAME}.goodwillMudAndTapeOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.mudAndTape`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillMudAndTapeOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Mud and Tape Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillMudAndTape`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Mud and Tape Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillMudAndTapeClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Add any other detail you can about the Mud and Tape needs",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeMudTapeForm
